@if (formModal && dataModal && medicalLimits) {
  <div class="modal-add-value-form-by-id-container" [formGroup]="formModal">
    <div class="header-container">
      <h2>{{ 'misuration.modalMisuration.title.' + dataModal.id | translate }}</h2>
      <p>{{ 'misuration.modalMisuration.subtitle.' + dataModal.id | translate }}</p>
    </div>

    <div class="content-container">
      <!-- Selezione Data -->
      @if (dataModal.id !== 'isSmoker' && dataModal.id !== 'bloodGroup') {
        <span>{{ 'misuration.modalMisuration.date_and_time' | translate }}</span>
        <div class="date-container">
          <app-aria-date-picker-field
            [label]="''"
            [minDate]="startDate"
            [maxDate]="todayDate"
            [placeholder]="'misuration.modalMisuration.choose' | translate"
            mode="single"
            mobileDrawer="auto"
            formControlName="creationDate"
          ></app-aria-date-picker-field>
          <nz-time-picker
            nzFormat="HH:mm"
            formControlName="creationHour"
            [attr.aria-label]="'misuration.modalMisuration.date_and_time' | translate"
          ></nz-time-picker>
        </div>
      }

      <!-- Pressione Arteriosa -->
      @if (dataModal.id === 'pressure') {
        <div class="flex-content">
          <div class="form-field">
            <span>{{ 'misuration.modalMisuration.maximum_pressure' | translate }}</span>
            <ds-input-text [control]="formModal.get('maxValue')" [placeholder]="'misuration.modalMisuration.insert' | translate"></ds-input-text>
            <span class="label-text"> {{'between' | translate}} {{ medicalLimits?.pressureLimits?.systolic?.min }} - {{ medicalLimits?.pressureLimits?.systolic?.max }}</span>
          </div>
          <div class="form-field">
            <span>{{ 'misuration.modalMisuration.minimum_pressure' | translate }}</span>
            <ds-input-text [control]="formModal.get('minValue')" [placeholder]="'misuration.modalMisuration.insert' | translate"></ds-input-text>
            <span class="label-text">{{'between' | translate}} {{ medicalLimits?.pressureLimits?.diastolic?.min }} - {{ medicalLimits?.pressureLimits?.diastolic?.max }}</span>
          </div>
          <div class="form-field">
            <span>BPM</span>
            <ds-input-text [control]="formModal.get('pressureBpm')" [placeholder]="'misuration.modalMisuration.insert' | translate"> </ds-input-text>
            <span class="label-text">{{'between' | translate}} {{ medicalLimits?.bpmLimits?.min }} - {{ medicalLimits?.bpmLimits?.max }}</span>
          </div>
        </div>
      }

      <!-- Peso Corporeo -->
      @if (dataModal.id === 'weight') {
        <div class="form-field">
          <span>{{ 'misuration.modalMisuration.weight' | translate }}</span>
          <ds-input-text [control]="formModal.get('weight')" [placeholder]="'misuration.modalMisuration.insert' | translate"></ds-input-text>
          <span class="label-text">{{'between' | translate}} {{ medicalLimits?.weightLimit?.min }} - {{ medicalLimits?.weightLimit?.max }}</span>
        </div>
      }

      <!-- Temperatura -->
      @if (dataModal.id === 'temperature') {
        <div class="form-field">
          <span>{{ 'misuration.modalMisuration.temperature' | translate }}</span>
          <ds-input-text [control]="formModal.get('temperature')" [placeholder]="'misuration.modalMisuration.insert' | translate"></ds-input-text>
          <span class="label-text">{{'between' | translate}} {{ medicalLimits?.temperatureLimits?.celsius?.min }} - {{ medicalLimits?.temperatureLimits?.celsius?.max }}</span>
        </div>
      }

      <!-- Frequenza Cardiaca -->
      @if (dataModal.id === 'bpm') {
        <div class="form-field">
          <span>{{ 'misuration.modalMisuration.bpm' | translate }}</span>
          <ds-input-text [control]="formModal.get('bpm')" [placeholder]="'misuration.modalMisuration.insert' | translate"></ds-input-text>
          <span class="label-text">{{'between' | translate}} {{ medicalLimits?.bpmLimits?.min }} - {{ medicalLimits?.bpmLimits?.max }}</span>
        </div>
      }

      <!-- Glicemia -->
      @if (dataModal.id === 'glycemia') {
        <div style="display: flex; align-items: center">
          <div class="form-field">
            <app-aria-autocomplete-field
             class="glycemia"
             [label]="'Alimentazione'"
             [placeholder]="'Seleziona lo stato alimentare'"
             [options]="glycemiaFoodOptions"
             formControlName="measureType"
            ></app-aria-autocomplete-field>
          </div>
          <div class="form-field">
            <app-aria-autocomplete-field
             class="glycemia"
             [label]="'Tipo misurazione'"
             [placeholder]="'Seleziona il tipo di misurazione'"
             [options]="glycemiaMeasurementOptions"
             formControlName="measureUnit"
></app-aria-autocomplete-field>
          </div>
          <div>
            <span style="margin-top: 0 !important">{{ 'misuration.modalMisuration.glycemia' | translate }}</span>
            <ds-input-text [control]="formModal.get('glycemia')" [placeholder]="'misuration.modalMisuration.insert' | translate"></ds-input-text>
            <span class="label-text">{{'between' | translate}} {{ medicalLimits?.glycemiaLimits?.min }} - {{ medicalLimits?.glycemiaLimits?.max }}</span>
          </div>
        </div>
      }

      <!-- Parametri generici -->
      @if (
        dataModal.id !== 'isSmoker' &&
        dataModal.id !== 'pressure' &&
        dataModal.id !== 'glycemia' &&
        dataModal.id !== 'bpm' &&
        dataModal.id !== 'weight' &&
        dataModal.id !== 'temperature' &&
        dataModal.id !== 'bloodGroup'
      ) {
        <div class="form-field">
          <span>{{ 'misuration.modalMisuration.' + [dataModal.id] | translate }}</span>
          <ds-input-text [type]="'number'" [control]="formModal.get(dataModal.id)" [placeholder]="'misuration.modalMisuration.insert' | translate"></ds-input-text>
        </div>
      }

      <!-- isSmoker -->
      @if (dataModal.id === 'isSmoker') {
        <span>{{ 'misuration.modalMisuration.' + [dataModal.id] | translate }}</span>
        <div class="form-field">
          <nz-radio-group role="radiogroup" aria-label="Scegli il tuo stato di fumatore" [formControl]="getControl('isSmoker')">
            <label nz-radio [nzValue]="true" aria-label="Sì, fumo">{{ 'misuration.modalMisuration.yes' | translate }}</label>
            <label nz-radio [nzValue]="false" aria-label="No, non fumo">{{ 'misuration.modalMisuration.no' | translate }}</label>
          </nz-radio-group>
        </div>
      }

      <!-- Blood group -->
      @if (dataModal.id === 'bloodGroup') {
        <div>
          <app-aria-autocomplete-field
           [label]="'misuration.modalMisuration.blood_group' | translate"
           [placeholder]="'misuration.modalMisuration.choose' | translate"
           [options]="bloodGroupOptions"
           formControlName="bloodGroup"
></app-aria-autocomplete-field>
        </div>
      }
    </div>

    <div class="button-container">
      <ds-button class="button-exit" [text]="'buttons.exit' | translate" [styleType]="'empty-main'" [width]="'small'" (click)="close()"></ds-button>
      <ds-button class="button-register" [text]="'buttons.regist' | translate" [width]="'small'" (click)="register()" [isDisabled]="formModal.invalid"></ds-button>
    </div>
  </div>
}
